/**
 * Comprehensive Phrases Data - Part 1
 * 小学阶段核心短语 - 第1部分
 *
 * 本文件包含小学3-6年级必学的约200个高频短语
 */

import { Phrase } from './phrases-types';

// ==================== 小学3-4年级基础短语（Elementary Grade 3-4）====================

export const elementaryGrade3to4Phrases: Phrase[] = [
  // ==================== 1. 问候与告别 Greetings (20) ====================
  {
    id: 'greet_hello',
    phrase: 'Hello!',
    phonetic: '/həˈloʊ/',
    meaning: '你好！',
    usageScenario: '见面时的问候，可用于任何时间，正式或非正式场合都适用',
    example: 'Hello! How are you today?',
    exampleTranslation: '你好！你今天好吗？',
    category: 'greetings',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'greet_hi',
    phrase: 'Hi!',
    phonetic: '/haɪ/',
    meaning: '嗨！你好！',
    usageScenario: '非正式的问候，用于朋友、同学、家人等熟人之间',
    example: 'Hi! Nice to see you!',
    exampleTranslation: '嗨！很高兴见到你！',
    category: 'greetings',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'greet_good_morning',
    phrase: 'Good morning!',
    phonetic: '/ɡʊd ˈmɔːrnɪŋ/',
    meaning: '早上好！',
    usageScenario: '早晨见面时的问候，通常用于中午12点之前',
    example: 'Good morning, teacher!',
    exampleTranslation: '早上好，老师！',
    category: 'greetings',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'greet_good_afternoon',
    phrase: 'Good afternoon!',
    phonetic: '/ɡʊd ˌæftərˈnuːn/',
    meaning: '下午好！',
    usageScenario: '下午见面时的问候，通常用于中午12点到下午6点之间',
    example: 'Good afternoon, everyone!',
    exampleTranslation: '大家下午好！',
    category: 'greetings',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'greet_good_evening',
    phrase: 'Good evening!',
    phonetic: '/ɡʊd ˈiːvnɪŋ/',
    meaning: '晚上好！',
    usageScenario: '晚上见面时的问候，通常用于下午6点之后',
    example: 'Good evening, Mom and Dad!',
    exampleTranslation: '晚上好，爸爸妈妈！',
    category: 'greetings',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'greet_good_night',
    phrase: 'Good night!',
    phonetic: '/ɡʊd naɪt/',
    meaning: '晚安！',
    usageScenario: '睡觉前或晚上告别时说，是道别语而不是问候语',
    example: 'Good night! See you tomorrow!',
    exampleTranslation: '晚安！明天见！',
    category: 'greetings',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'greet_goodbye',
    phrase: 'Goodbye!',
    phonetic: '/ɡʊdˈbaɪ/',
    meaning: '再见！',
    usageScenario: '正式或非正式的告别用语，可用于任何场合',
    example: 'Goodbye! Have a nice day!',
    exampleTranslation: '再见！祝你愉快！',
    category: 'greetings',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'greet_bye',
    phrase: 'Bye!',
    phonetic: '/baɪ/',
    meaning: '再见！',
    usageScenario: '非正式的告别用语，用于朋友或熟人之间',
    example: 'Bye! See you later!',
    exampleTranslation: '再见！回头见！',
    category: 'greetings',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'greet_see_you',
    phrase: 'See you!',
    phonetic: '/siː juː/',
    meaning: '再见！回头见！',
    usageScenario: '非正式的告别用语，暗示很快会再见面',
    example: 'See you tomorrow!',
    exampleTranslation: '明天见！',
    category: 'greetings',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'greet_see_you_later',
    phrase: 'See you later!',
    phonetic: '/siː juː ˈleɪtər/',
    meaning: '回头见！',
    usageScenario: '非正式的告别用语，表示稍后会再见面',
    example: 'I have to go now. See you later!',
    exampleTranslation: '我得走了。回头见！',
    category: 'greetings',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'greet_how_are_you',
    phrase: 'How are you?',
    phonetic: '/haʊ ɑːr juː/',
    meaning: '你好吗？',
    usageScenario: '问候对方的健康或近况，是常用的见面问候语',
    example: 'Hello! How are you?',
    exampleTranslation: '你好！你好吗？',
    category: 'greetings',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'greet_nice_to_meet_you',
    phrase: 'Nice to meet you!',
    phonetic: '/naɪs tuː miːt juː/',
    meaning: '很高兴见到你！',
    usageScenario: '第一次见面认识新朋友时说',
    example: 'Nice to meet you! My name is Tom.',
    exampleTranslation: '很高兴见到你！我叫Tom。',
    category: 'greetings',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'greet_nice_to_see_you',
    phrase: 'Nice to see you!',
    phonetic: '/naɪs tuː siː juː/',
    meaning: '很高兴见到你！',
    usageScenario: '见到熟人时的问候，表示很高兴见到对方',
    example: 'Nice to see you again!',
    exampleTranslation: '很高兴再次见到你！',
    category: 'greetings',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'greet_welcome',
    phrase: 'Welcome!',
    phonetic: '/ˈwelkəm/',
    meaning: '欢迎！',
    usageScenario: '欢迎某人来到某个地方',
    example: 'Welcome to our school!',
    exampleTranslation: '欢迎来到我们学校！',
    category: 'greetings',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'greet_welcome_back',
    phrase: 'Welcome back!',
    phonetic: '/ˈwelkəm bæk/',
    meaning: '欢迎回来！',
    usageScenario: '欢迎某人回来或返回',
    example: 'Welcome back to school!',
    exampleTranslation: '欢迎回到学校！',
    category: 'greetings',
    difficulty: 'easy',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },

  // ==================== 2. 礼貌用语 Politeness (20) ====================
  {
    id: 'polite_thank_you',
    phrase: 'Thank you!',
    phonetic: '/θæŋk juː/',
    meaning: '谢谢！',
    usageScenario: '表达感谢，接受帮助或礼物时说，是最常用的感谢用语',
    example: 'Thank you for your help!',
    exampleTranslation: '谢谢你的帮助！',
    category: 'politeness',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'polite_thanks',
    phrase: 'Thanks!',
    phonetic: '/θæŋks/',
    meaning: '谢谢！',
    usageScenario: '非正式的感谢用语，用于朋友或熟人之间，比Thank you更随意',
    example: 'Thanks a lot!',
    exampleTranslation: '非常感谢！',
    category: 'politeness',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'polite_thank_you_very_much',
    phrase: 'Thank you very much!',
    phonetic: '/θæŋk juː ˈveri mʌtʃ/',
    meaning: '非常感谢！',
    usageScenario: '表达强烈的感谢，比Thank you更正式和诚恳',
    example: 'Thank you very much for the gift!',
    exampleTranslation: '非常感谢你的礼物！',
    category: 'politeness',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'polite_thanks_a_lot',
    phrase: 'Thanks a lot!',
    phonetic: '/θæŋks ə lɒt/',
    meaning: '非常感谢！',
    usageScenario: '非正式但强烈地表达感谢',
    example: 'Thanks a lot for your help!',
    exampleTranslation: '非常感谢你的帮助！',
    category: 'politeness',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'polite_youre_welcome',
    phrase: "You're welcome!",
    phonetic: '/jʊər ˈwelkəm/',
    meaning: '不客气！',
    usageScenario: '回应别人的感谢时说，是最常用的回答',
    example: "Thank you! - You're welcome!",
    exampleTranslation: '谢谢！- 不客气！',
    category: 'politeness',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'polite_thats_ok',
    phrase: "That's OK!",
    phonetic: '/ðæts oʊˈkeɪ/',
    meaning: '没关系！/ 不客气！',
    usageScenario: '回应感谢或道歉时说，表示不用在意',
    example: "Sorry I'm late. - That's OK!",
    exampleTranslation: '对不起我迟到了。- 没关系！',
    category: 'politeness',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'polite_no_problem',
    phrase: 'No problem!',
    phonetic: '/noʊ ˈprɒbləm/',
    meaning: '没问题！/ 没关系！',
    usageScenario: '回应感谢或道歉时说，表示乐意帮忙或原谅，比较随意',
    example: "Can you help me? - No problem!",
    exampleTranslation: '你能帮我吗？- 没问题！',
    category: 'politeness',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'polite_please',
    phrase: 'Please.',
    phonetic: '/pliːz/',
    meaning: '请。',
    usageScenario: '请求时表示礼貌，放在句末或单独使用表示同意',
    example: 'Can I have some water, please?',
    exampleTranslation: '请给我一些水好吗？',
    category: 'politeness',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'polite_excuse_me',
    phrase: 'Excuse me.',
    phonetic: '/ɪkˈskjuːz miː/',
    meaning: '打扰一下。/ 借过。',
    usageScenario: '引起别人注意、借过、或道歉时说，非常常用的礼貌用语',
    example: 'Excuse me, where is the library?',
    exampleTranslation: '打扰一下，图书馆在哪里？',
    category: 'politeness',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'polite_im_sorry',
    phrase: "I'm sorry.",
    phonetic: '/aɪm ˈsɒri/',
    meaning: '对不起。/ 我很抱歉。',
    usageScenario: '做错事或表示遗憾时说',
    example: "I'm sorry I'm late.",
    exampleTranslation: '对不起我迟到了。',
    category: 'politeness',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'polite_sorry',
    phrase: 'Sorry!',
    phonetic: '/ˈsɒri/',
    meaning: '对不起！',
    usageScenario: '非正式的道歉用语',
    example: "Sorry, I don't know.",
    exampleTranslation: '对不起，我不知道。',
    category: 'politeness',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'polite_never_mind',
    phrase: 'Never mind.',
    phonetic: '/ˈnevər maɪnd/',
    meaning: '没关系。/ 别在意。',
    usageScenario: '回应道歉时说，表示不在意或不重要',
    example: "I'm sorry I broke your pen. - Never mind.",
    exampleTranslation: '对不起我弄坏了你的钢笔。- 没关系。',
    category: 'politeness',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'polite_it_doesnt_matter',
    phrase: "It doesn't matter.",
    phonetic: '/ɪt ˈdʌznt ˈmætər/',
    meaning: '没关系。/ 无所谓。',
    usageScenario: '回应道歉时说，表示不在意',
    example: "Sorry, I forgot. - It doesn't matter.",
    exampleTranslation: '对不起，我忘了。- 没关系。',
    category: 'politeness',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'polite_not_at_all',
    phrase: 'Not at all!',
    phonetic: '/nɒt æt ɔːl/',
    meaning: '一点也不！/ 别客气！',
    usageScenario: '回应感谢时说，表示不用客气',
    example: "Thank you for your help. - Not at all!",
    exampleTranslation: '谢谢你的帮助。- 别客气！',
    category: 'politeness',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'polite_with_pleasure',
    phrase: 'With pleasure!',
    phonetic: '/wɪð ˈpleʒər/',
    meaning: '很乐意！',
    usageScenario: '答应别人的请求时说，表示愿意帮助',
    example: 'Can you help me? - With pleasure!',
    exampleTranslation: '你能帮我吗？- 很乐意！',
    category: 'politeness',
    difficulty: 'medium',
    grade: '6',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'polite_after_you',
    phrase: 'After you!',
    phonetic: '/ˈæftər juː/',
    meaning: '您先请！',
    usageScenario: '礼貌地让别人先走或先做某事',
    example: 'After you, please!',
    exampleTranslation: '您先请！',
    category: 'politeness',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'low'
  },
  {
    id: 'polite_pardon',
    phrase: 'Pardon?',
    phonetic: '/ˈpɑːrdn/',
    meaning: '请再说一遍？',
    usageScenario: '没听清对方的话时，礼貌地要求重复',
    example: "Pardon? I didn't hear you.",
    exampleTranslation: '请再说一遍？我没听清。',
    category: 'politeness',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'polite_excuse_me_what',
    phrase: 'Excuse me?',
    phonetic: '/ɪkˈskjuːz miː/',
    meaning: '不好意思，请再说一遍？',
    usageScenario: '没听清对方的话时，礼貌地要求重复',
    example: "Excuse me? Can you say that again?",
    exampleTranslation: '不好意思，请再说一遍？',
    category: 'politeness',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },

  // ==================== 3. 日常表达 Daily Expressions (30) ====================
  {
    id: 'daily_i_like',
    phrase: 'I like...',
    phonetic: '/aɪ laɪk/',
    meaning: '我喜欢……',
    usageScenario: '表达喜欢某事物，后接名词或动名词',
    example: 'I like apples very much.',
    exampleTranslation: '我非常喜欢苹果。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'daily_i_dont_like',
    phrase: "I don't like...",
    phonetic: '/aɪ doʊnt laɪk/',
    meaning: '我不喜欢……',
    usageScenario: '表达不喜欢某事物',
    example: "I don't like rainy days.",
    exampleTranslation: '我不喜欢下雨天。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'daily_i_love',
    phrase: 'I love...',
    phonetic: '/aɪ lʌv/',
    meaning: '我爱……/ 我非常喜欢……',
    usageScenario: '表达强烈的喜欢或爱，比like程度更深',
    example: 'I love my family.',
    exampleTranslation: '我爱我的家人。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'daily_i_want',
    phrase: 'I want...',
    phonetic: '/aɪ wɒnt/',
    meaning: '我想要……',
    usageScenario: '表达想要某事物，后接名词',
    example: 'I want some juice, please.',
    exampleTranslation: '我想要一些果汁。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'daily_i_want_to',
    phrase: 'I want to...',
    phonetic: '/aɪ wɒnt tuː/',
    meaning: '我想要……（做某事）',
    usageScenario: '表达想要做某事，后接动词原形',
    example: 'I want to play football.',
    exampleTranslation: '我想要踢足球。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'daily_i_have',
    phrase: 'I have...',
    phonetic: '/aɪ hæv/',
    meaning: '我有……',
    usageScenario: '表达拥有某事物',
    example: 'I have a new book.',
    exampleTranslation: '我有一本新书。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'daily_i_have_a',
    phrase: 'I have a...',
    phonetic: '/aɪ hæv ə/',
    meaning: '我有一个……',
    usageScenario: '介绍自己拥有的事物',
    example: 'I have a dog. Its name is Lucky.',
    exampleTranslation: '我有一条狗。它叫Lucky。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'daily_i_dont_have',
    phrase: "I don't have...",
    phonetic: '/aɪ doʊnt hæv/',
    meaning: '我没有……',
    usageScenario: '表达没有某事物',
    example: "I don't have any money.",
    exampleTranslation: '我没有钱。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'daily_i_am',
    phrase: 'I am...',
    phonetic: '/aɪ æm/',
    meaning: '我是……',
    usageScenario: '介绍自己或描述自己的状态',
    example: 'I am a student.',
    exampleTranslation: '我是一名学生。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'daily_im',
    phrase: "I'm...",
    phonetic: '/aɪm/',
    meaning: '我是……/ 我……',
    usageScenario: "I am的缩写形式，更口语化，用于描述状态或身份",
    example: "I'm happy today.",
    exampleTranslation: '我今天很开心。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'daily_this_is',
    phrase: 'This is...',
    phonetic: '/ðɪs ɪz/',
    meaning: '这是……',
    usageScenario: '介绍近处的人或物',
    example: 'This is my friend, Tom.',
    exampleTranslation: '这是我的朋友，Tom。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'daily_that_is',
    phrase: 'That is...',
    phonetic: '/ðæt ɪz/',
    meaning: '那是……',
    usageScenario: '介绍远处的人或物',
    example: 'That is a beautiful bird.',
    exampleTranslation: '那是一只美丽的鸟。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'daily_thats',
    phrase: "That's...",
    phonetic: '/ðæts/',
    meaning: '那是……',
    usageScenario: "That is的缩写形式，更口语化",
    example: "That's a good idea!",
    exampleTranslation: '那是个好主意！',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'daily_it_is',
    phrase: 'It is...',
    phonetic: '/ɪt ɪz/',
    meaning: '它是……/ 这是……',
    usageScenario: '描述事物或情况',
    example: 'It is a sunny day.',
    exampleTranslation: '今天是个晴天。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'daily_its',
    phrase: "It's...",
    phonetic: '/ɪts/',
    meaning: '它是……/ 这是……',
    usageScenario: "It is的缩写形式，更口语化",
    example: "It's time for lunch.",
    exampleTranslation: '该吃午饭了。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'daily_there_is',
    phrase: 'There is...',
    phonetic: '/ðeər ɪz/',
    meaning: '有……/ 存在……',
    usageScenario: '表示某地存在某物（单数），是there be句型',
    example: 'There is a book on the desk.',
    exampleTranslation: '桌子上有一本书。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'daily_there_are',
    phrase: 'There are...',
    phonetic: '/ðeər ɑːr/',
    meaning: '有……/ 存在……',
    usageScenario: '表示某地存在某物（复数），是there be句型',
    example: 'There are many birds in the sky.',
    exampleTranslation: '天空中有许多鸟。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'daily_lets',
    phrase: "Let's...",
    phonetic: '/lets/',
    meaning: '让我们……',
    usageScenario: '提议一起做某事，后接动词原形',
    example: "Let's play together!",
    exampleTranslation: '让我们一起玩吧！',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'daily_lets_go',
    phrase: "Let's go!",
    phonetic: '/lets ɡoʊ/',
    meaning: '我们走吧！',
    usageScenario: '提议一起出发或开始行动',
    example: "It's late. Let's go!",
    exampleTranslation: '很晚了。我们走吧！',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'daily_i_think',
    phrase: 'I think...',
    phonetic: '/aɪ θɪŋk/',
    meaning: '我认为……/ 我觉得……',
    usageScenario: '表达个人观点或想法',
    example: 'I think it is a good idea.',
    exampleTranslation: '我认为这是个好主意。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'daily_i_know',
    phrase: 'I know.',
    phonetic: '/aɪ noʊ/',
    meaning: '我知道。',
    usageScenario: '表示了解或知道某事',
    example: 'I know the answer!',
    exampleTranslation: '我知道答案！',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'daily_i_dont_know',
    phrase: "I don't know.",
    phonetic: '/aɪ doʊnt noʊ/',
    meaning: '我不知道。',
    usageScenario: '表示不了解或不知道某事',
    example: "Where is the library? - I don't know.",
    exampleTranslation: '图书馆在哪里？- 我不知道。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'daily_i_see',
    phrase: 'I see.',
    phonetic: '/aɪ siː/',
    meaning: '我明白了。/ 我知道了。',
    usageScenario: '表示理解了某事',
    example: 'I see. Thank you for telling me.',
    exampleTranslation: '我明白了。谢谢你告诉我。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'daily_my_name_is',
    phrase: 'My name is...',
    phonetic: '/maɪ neɪm ɪz/',
    meaning: '我的名字是……',
    usageScenario: '自我介绍时说出自己的名字',
    example: 'My name is Amy. What is your name?',
    exampleTranslation: '我叫Amy。你叫什么名字？',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'daily_im_years_old',
    phrase: "I'm ... years old.",
    phonetic: '/aɪm ... jɪərz oʊld/',
    meaning: '我……岁了。',
    usageScenario: '回答年龄或介绍自己的年龄',
    example: "I'm ten years old.",
    exampleTranslation: '我十岁了。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'daily_i_come_from',
    phrase: 'I come from...',
    phonetic: '/aɪ kʌm frɒm/',
    meaning: '我来自……',
    usageScenario: '介绍自己的籍贯或来自哪里',
    example: 'I come from China.',
    exampleTranslation: '我来自中国。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'daily_im_from',
    phrase: "I'm from...",
    phonetic: '/aɪm frɒm/',
    meaning: '我来自……',
    usageScenario: '介绍自己的籍贯或来自哪里（更口语化）',
    example: "I'm from Beijing, China.",
    exampleTranslation: '我来自中国北京。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'daily_i_live_in',
    phrase: 'I live in...',
    phonetic: '/aɪ lɪv ɪn/',
    meaning: '我住在……',
    usageScenario: '介绍自己的居住地',
    example: 'I live in Shanghai.',
    exampleTranslation: '我住在上海。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'daily_i_study_at',
    phrase: 'I study at...',
    phonetic: '/aɪ ˈstʌdi æt/',
    meaning: '我在……学习。',
    usageScenario: '介绍自己在哪里上学',
    example: 'I study at No. 1 Primary School.',
    exampleTranslation: '我在第一小学上学。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'daily_it_looks_like',
    phrase: 'It looks like...',
    phonetic: '/ɪt lʊks laɪk/',
    meaning: '它看起来像……',
    usageScenario: '描述事物的外观或样子',
    example: 'It looks like a cat.',
    exampleTranslation: '它看起来像一只猫。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },

  // ==================== 4. 询问表达 Asking (25) ====================
  {
    id: 'ask_what_is_this',
    phrase: 'What is this?',
    phonetic: '/wɒt ɪz ðɪs/',
    meaning: '这是什么？',
    usageScenario: '询问近处的事物',
    example: 'What is this? It is a pen.',
    exampleTranslation: '这是什么？这是一支钢笔。',
    category: 'asking',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'ask_what_is_that',
    phrase: 'What is that?',
    phonetic: '/wɒt ɪz ðæt/',
    meaning: '那是什么？',
    usageScenario: '询问远处的事物',
    example: 'What is that? It is a bird.',
    exampleTranslation: '那是什么？那是一只鸟。',
    category: 'asking',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'ask_whats_this',
    phrase: "What's this?",
    phonetic: '/wɒts ðɪs/',
    meaning: '这是什么？',
    usageScenario: '询问近处的事物（口语形式）',
    example: "What's this in English?",
    exampleTranslation: '这个用英语怎么说？',
    category: 'asking',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'ask_whats_that',
    phrase: "What's that?",
    phonetic: '/wɒts ðæt/',
    meaning: '那是什么？',
    usageScenario: '询问远处的事物（口语形式）',
    example: "What's that over there?",
    exampleTranslation: '那边那个是什么？',
    category: 'asking',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'ask_what_are_these',
    phrase: 'What are these?',
    phonetic: '/wɒt ɑːr ðiːz/',
    meaning: '这些是什么？',
    usageScenario: '询问近处的多个事物',
    example: 'What are these? They are apples.',
    exampleTranslation: '这些是什么？这些是苹果。',
    category: 'asking',
    difficulty: 'medium',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'ask_what_are_those',
    phrase: 'What are those?',
    phonetic: '/wɒt ɑːr ðoʊz/',
    meaning: '那些是什么？',
    usageScenario: '询问远处的多个事物',
    example: 'What are those? They are birds.',
    exampleTranslation: '那些是什么？那些是鸟。',
    category: 'asking',
    difficulty: 'medium',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'ask_where_is',
    phrase: 'Where is...?',
    phonetic: '/weər ɪz/',
    meaning: '……在哪里？',
    usageScenario: '询问某人或某物的位置（单数）',
    example: 'Where is my book?',
    exampleTranslation: '我的书在哪里？',
    category: 'asking',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'ask_where_are',
    phrase: 'Where are...?',
    phonetic: '/weər ɑːr/',
    meaning: '……在哪里？',
    usageScenario: '询问多个事物的位置（复数）',
    example: 'Where are my shoes?',
    exampleTranslation: '我的鞋子在哪里？',
    category: 'asking',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'ask_wheres',
    phrase: "Where's...?",
    phonetic: '/weərz/',
    meaning: '……在哪里？',
    usageScenario: 'Where is的缩写形式，更口语化',
    example: "Where's the library?",
    exampleTranslation: '图书馆在哪里？',
    category: 'asking',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'ask_who_is',
    phrase: 'Who is...?',
    phonetic: '/huː ɪz/',
    meaning: '……是谁？',
    usageScenario: '询问人物身份',
    example: 'Who is that boy?',
    exampleTranslation: '那个男孩是谁？',
    category: 'asking',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'ask_whos',
    phrase: "Who's...?",
    phonetic: '/huːz/',
    meaning: '……是谁？',
    usageScenario: 'Who is的缩写形式，更口语化',
    example: "Who's that girl?",
    exampleTranslation: '那个女孩是谁？',
    category: 'asking',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'ask_how_many',
    phrase: 'How many...?',
    phonetic: '/haʊ ˈmeni/',
    meaning: '多少……？',
    usageScenario: '询问数量（可数名词），后接可数名词复数',
    example: 'How many apples do you have?',
    exampleTranslation: '你有多少个苹果？',
    category: 'asking',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'ask_how_much',
    phrase: 'How much...?',
    phonetic: '/haʊ mʌtʃ/',
    meaning: '多少……？',
    usageScenario: '询问数量（不可数名词）或价格',
    example: 'How much is this book?',
    exampleTranslation: '这本书多少钱？',
    category: 'asking',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'ask_what_color',
    phrase: 'What color...?',
    phonetic: '/wɒt ˈkʌlər/',
    meaning: '什么颜色……？',
    usageScenario: '询问颜色',
    example: 'What color is your bag?',
    exampleTranslation: '你的书包是什么颜色？',
    category: 'asking',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'ask_what_time',
    phrase: 'What time...?',
    phonetic: '/wɒt taɪm/',
    meaning: '几点……？',
    usageScenario: '询问时间',
    example: 'What time is it now?',
    exampleTranslation: '现在几点了？',
    category: 'asking',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'ask_what_day',
    phrase: 'What day...?',
    phonetic: '/wɒt deɪ/',
    meaning: '星期几……？',
    usageScenario: '询问星期几',
    example: 'What day is it today?',
    exampleTranslation: '今天是星期几？',
    category: 'asking',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'ask_what_about',
    phrase: 'What about...?',
    phonetic: '/wɒt əˈbaʊt/',
    meaning: '……怎么样？',
    usageScenario: '询问意见或提出建议',
    example: 'What about you?',
    exampleTranslation: '你呢？',
    category: 'asking',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'ask_how_about',
    phrase: 'How about...?',
    phonetic: '/haʊ əˈbaʊt/',
    meaning: '……怎么样？',
    usageScenario: '询问意见或提出建议',
    example: 'How about going to the park?',
    exampleTranslation: '去公园怎么样？',
    category: 'asking',
    difficulty: 'easy',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'ask_whats_your_name',
    phrase: "What's your name?",
    phonetic: '/wɒts jʊər neɪm/',
    meaning: '你叫什么名字？',
    usageScenario: '询问对方的姓名',
    example: 'Hello! What is your name?',
    exampleTranslation: '你好！你叫什么名字？',
    category: 'asking',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'ask_how_old_are_you',
    phrase: 'How old are you?',
    phonetic: '/haʊ oʊld ɑːr juː/',
    meaning: '你几岁了？',
    usageScenario: '询问对方的年龄',
    example: 'How old are you? - I am seven years old.',
    exampleTranslation: '你几岁了？- 我七岁了。',
    category: 'asking',
    difficulty: 'easy',
    grade: '3',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'ask_where_are_you_from',
    phrase: 'Where are you from?',
    phonetic: '/weər ɑːr juː frɒm/',
    meaning: '你来自哪里？',
    usageScenario: '询问对方的籍贯或来自哪里',
    example: 'Where are you from? - I am from China.',
    exampleTranslation: '你来自哪里？- 我来自中国。',
    category: 'asking',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'ask_where_do_you_live',
    phrase: 'Where do you live?',
    phonetic: '/weər duː juː lɪv/',
    meaning: '你住在哪里？',
    usageScenario: '询问对方的居住地',
    example: 'Where do you live? - I live in Beijing.',
    exampleTranslation: '你住在哪里？- 我住在北京。',
    category: 'asking',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'high'
  },
  {
    id: 'ask_which_one',
    phrase: 'Which one...?',
    phonetic: '/wɪtʃ wʌn/',
    meaning: '哪一个……？',
    usageScenario: '在多个选项中询问具体哪一个',
    example: 'Which one is your bag?',
    exampleTranslation: '哪一个是你的书包？',
    category: 'asking',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'ask_whose_is_this',
    phrase: 'Whose is this?',
    phonetic: '/huːz ɪz ðɪs/',
    meaning: '这是谁的？',
    usageScenario: '询问物品的主人',
    example: 'Whose is this book? - It is mine.',
    exampleTranslation: '这是谁的书？- 是我的。',
    category: 'asking',
    difficulty: 'medium',
    grade: '5',
    level: 'elementary',
    frequency: 'medium'
  },
  {
    id: 'ask_why',
    phrase: 'Why...?',
    phonetic: '/waɪ/',
    meaning: '为什么……？',
    usageScenario: '询问原因或理由',
    example: 'Why are you happy?',
    exampleTranslation: '你为什么开心？',
    category: 'asking',
    difficulty: 'easy',
    grade: '4',
    level: 'elementary',
    frequency: 'high'
  },
];

// 由于数据量较大，将在下一个文件中继续...
